import { useQuery } from 'react-query'
import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

// OncoTree tumour types, for the analysis wizard's somatic step.
//
// This is not decoration. OncoKB evidence levels are PER-INDICATION: the same
// variant is LEVEL_1 in melanoma and LEVEL_3B in colorectal cancer. An analysis
// submitted without a code runs untyped, OncoKB answers tumour-agnostically, and
// the somatic ranking deliberately withholds its therapeutic-level term because
// a tumour-agnostic level would rank every actionable variant identically.
//
// Searched server-side rather than shipped to the client: the ranking keys on
// the OncoTree hierarchy depth so the canonical node ("Melanoma") outranks the
// 20 subtypes whose name merely contains the word, and a reference rebuild then
// reaches the wizard without a frontend deploy.

export const fetchOncotree = async (query, limit = 25) => {
  const { data } = await axios.get(`${API_BASE_URL}/oncotree/search`, {
    params: { q: query || '', limit },
  })
  return data?.results ?? []
}

/**
 * Typeahead results. An empty query is valid and returns the canonical level 1-2
 * types, so the dropdown opens on something useful rather than on 897 subtypes.
 */
export const useOncotreeSearch = (query, { enabled = true, limit = 25 } = {}) =>
  useQuery(['oncotree', 'search', query, limit], () => fetchOncotree(query, limit), {
    enabled,
    // The list only changes when the reference parquet is rebuilt, so results are
    // safe to hold for the length of a wizard session; this keeps keystrokes from
    // re-hitting the API once a term has been seen.
    staleTime: 10 * 60 * 1000,
    keepPreviousData: true,
  })

export default useOncotreeSearch
